import { Action } from 'redux';
export const GET_HOMEPAGE_CONTENTS = 'driver-home-page/GET_HOMEPAGE_CONTENTS';
export const PERSIST_HOMEPAGE = 'driver-home-page/PERSIST_HOMEPAGE';
export const GET_DRIVER_HOME_PAGE_CONTENTS = 'driver-home-page/GET_DRIVER_HOME_PAGE_CONTENTS';
export const UPDATE_DRIVER_HOME_PAGE = 'driver-home-page/UPDATE_DRIVER_HOME_PAGE';
/**
 * Get home page contents
 */
export interface GetHomepageContentsAction extends Action<typeof GET_HOMEPAGE_CONTENTS> {
  payload: any;
}

export const getHomepageContents = (data: any): GetHomepageContentsAction => ({
  type: GET_HOMEPAGE_CONTENTS,
  payload: data,
});

export const getDriverHomepageContents = () => {
  return {
    type: GET_DRIVER_HOME_PAGE_CONTENTS,
  };
};

export const persistHomePage = (data: any) => ({
  type: PERSIST_HOMEPAGE,
  payload: data,
});
export const updateDriverHomePage = (data: any) => {
  return {
    type: UPDATE_DRIVER_HOME_PAGE,
    payload: data,
  };
};
